<template>
  <div id="app">
    <router-view />

    <layout-notification />

    <confirm
      v-model="showConfirm"
      v-if="confirm"
      :show-close-button="confirm.showCloseButton"
      :close-button="$t(confirm.closeButton)"
      :submit-button="$t(confirm.submitButton)"
      :title="confirm.title"
      :description="confirm.description"
      @submit="onConfirmSubmit()"
      @cancel="onConfirmCancel"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LayoutNotification from '@/components/layout/Notification.vue';
import Confirm from '@/components/dialogs/Confirm.vue';

export default {
  components: { LayoutNotification, Confirm },
  data() {
    return {
      showConfirm: false
    };
  },
  methods: {
    onConfirmSubmit() {
      this.confirm.onSuccess();
      this.showConfirm = false;
    },
    onConfirmCancel() {
      this.showConfirm = false;
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.confirm.confirm
    })
  },
  watch: {
    confirm(to, from) {
      if (to) {
        this.showConfirm = true;
      }
    }
  }
};
</script>

<style src="./styles/styles.scss" lang="scss" />
